<template>
  <v-layout>
    <v-layout column xs12>
      <v-card id="EmployeesTableContent" class="max-shadow">
        <v-toolbar flat color="white" text height="64">
          <v-spacer />
          <search-widget v-model="search" class="mx-2" />
          <v-btn
            color="primary"
            outlined
            class="mx-2"
            to="/admin/employees/add"
          >
            Add
          </v-btn>
          <v-btn
            to="/admin/employees/import"
            class="mx-2"
            color="primary"
            outlined
          >
            Import
          </v-btn>
          <v-btn color="primary" outlined class="mx-2" @click="exportEmployees">
            Export
          </v-btn>
          <v-btn color="primary" outlined class="mx-2" @click="resendInviteAll">
            Resend Invite All
          </v-btn>
        </v-toolbar>
        <v-layout column xs12 class="pa-0">
          <v-data-table
            id="employeeTable"
            :headers="employeesHeaders"
            :items="employees"
            :search="search"
            :loading="loading"
            :no-results-text="
              'Your search for ' + search + ' found no results.'
            "
            :pagination.sync="pagination"
            class="px-0 pb-2"
            item-key="id"
            :no-data-text="noDataText"
            @click:row="nav"
          >
            <template slot="items" slot-scope="props">
              <tr @click="$router.push('/admin/employees/' + props.item.id)">
                <td>{{ props.index + 1 }}</td>
                <td class="text-xs-left">
                  <avatar
                    :size="40"
                    :src="props.item.photo"
                    :text="props.item.name"
                  />
                </td>
                <td class="text-xs-left">
                  {{ props.item.name }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.email }}<br />
                  <span v-if="sholudShowError(props.item.account)">
                    <span style="color: red"
                      >Error: {{ getErrorMessage(props.item.account) }}</span
                    >
                  </span>
                </td>
                <td class="text-xs-left">
                  {{ props.item.phone }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.designation }}
                </td>
                <td class="text-xs-left px-0">
                  <v-btn
                    color="primary"
                    text
                    small
                    @click.stop="resendInvite(props.item)"
                  >
                    resend invite
                  </v-btn>
                </td>
                <td class="justify-center layout px-0">
                  <v-btn
                    icon
                    class="mx-0"
                    @click.stop="editEmployee(props.item)"
                  >
                    <v-icon color="grey darken-1"> edit </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="!sameUser(props.item.email)"
                    icon
                    class="mx-0"
                    @click.stop="deleteEmployee(props.item)"
                  >
                    <v-icon color="grey darken-1"> delete </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <!-- <template slot="items" slot-scope="props">
              <tr @click="$router.push('/admin/employees/' + props.item.id)">
                <td>{{ getIndex(props.index + 1) }}</td>
                <td class="text-xs-left">
                  <avatar :size="40" :src="props.item.photo" :text="props.item.name" />
                </td>
                <td class="text-xs-left">
                  {{ props.item.name }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.email }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.phone }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.designation }}
                </td>
                <td class="justify-center row px-0">
                  <v-btn icon class="mx-0" @click.stop="editEmployee(props.item)">
                    <v-icon color="grey darken-1">
                      edit
                    </v-icon>
                  </v-btn>
                  <v-btn icon class="mx-0" @click.stop="deleteEmployee(props.item)">
                    <v-icon color="grey darken-1">
                      delete
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template> -->
          </v-data-table>
        </v-layout>
      </v-card>
    </v-layout>
    <v-dialog v-model="editEmployeeDialog" max-width="600px">
      <edit-employee
        :employee="selectedEmployee"
        @update="editEmployeeDialog = false"
        @cancel="editEmployeeDialog = false"
      />
    </v-dialog>
    <v-dialog v-model="deleteEmployeeDialog" max-width="600px">
      <v-card class="max-shadow">
        <v-card-title primary-title>
          <div class="headline">Delete {{ selectedEmployee.name }}</div>
        </v-card-title>
        <v-card-text>
          <div class="subheading">
            Do you want to delete employee
            <strong>{{ selectedEmployee.name }}</strong
            >?
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click.stop="deleteEmployeeDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn text color="primary" @click.stop="confirmDeleteEmployee">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="resendInviteDialog" max-width="700px" persistent>
      <v-card>
        <v-card-title primary-title>
          <div class="headline">Resent invite</div>
        </v-card-title>
        <v-card-text>
          <div class="subtitle-1">
            Do you want to resend the invite for
            <strong>{{
              selectedEmployee.id ? selectedEmployee.email : employees.length
            }}</strong>
            {{ employees.length === 1 ? '?' : 'employees?' }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="secondary"
            @click.stop="resendInviteDialog = false"
          >
            no
          </v-btn>
          <v-btn
            depressed
            color="primary"
            :loading="resendingInvite"
            @click.stop="confirmResendInvite(selectedEmployee.id)"
          >
            yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="3000"
      top-right
      pb-2
    >
      {{ snackbarMessage }}
      <v-btn flat @click.native="snackbar = false"> Close </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import * as moment from 'moment';
import { get, cloneDeep } from 'lodash';
import axios from 'axios';

import { firestore, auth } from '@/firebase';
import validationRules from '@/mixins/validation-rules';

import avatar from '@/components/common/Avatar';
import SearchWidget from '@/components/common/SearchWidget';
import EditEmployee from './EditEmployee';
import { settings } from '../../../utils/settings';
import Papa from 'papaparse';
import { downloadFile } from '@/utils';

export default {
  name: 'EmployeesTable',
  components: {
    avatar,
    'search-widget': SearchWidget,
    EditEmployee,
  },
  mixins: [validationRules],
  data() {
    return {
      loading: true,
      employees: [],
      employeesHeaders: [
        {
          text: '#',
          value: false,
          align: 'left',
        },
        {
          text: 'Photo',
          value: 'photo',
          align: 'left',
        },
        {
          text: 'Name',
          value: 'name',
          align: 'left',
        },
        {
          text: 'Email',
          value: 'email',
          align: 'left',
        },
        {
          text: 'Phone',
          value: 'phone',
          align: 'left',
        },
        {
          text: 'Designation',
          value: 'designation',
          align: 'left',
        },
        {
          text: 'Invite',
          value: 'status',
          align: 'left',
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'right',
          sortable: false,
        },
      ],
      search: '',
      pagination: {
        rowsPerPage: 10,
      },
      firebaseListeners: [],
      selectedEmployee: {},
      editEmployeeDialog: false,
      deleteEmployeeDialog: false,
      resendingInvite: false,
      resendInviteDialog: false,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
    };
  },
  computed: {
    noDataText() {
      return this.loading ? '' : 'No employee is added';
    },
  },
  mounted() {
    this.employeesListener();
  },
  beforeDestroy() {
    // unsubscribe all firebase listeners
    this.firebaseListeners.forEach((listenerFunc) => {
      listenerFunc();
    });
  },

  methods: {
    sameUser(email) {
      return this.$store.state.profile.email == email;
    },

    employeesListener() {
      const el = firestore
        .collection('tenants')
        .doc(this.$store.state.profile.cid)
        .collection('employees')
        .onSnapshot((employeesSnapshot) => {
          this.loading = false;
          this.employees = [];
          employeesSnapshot.forEach((employeeSnapshot) => {
            const employee = employeeSnapshot.data();
            employee.id = employeeSnapshot.id;
            this.employees.push(employee);
          });
        });
      this.firebaseListeners.push(el);
    },
    getIndex(index) {
      const { page, rowsPerPage } = this.pagination;
      return index + (page - 1) * rowsPerPage;
    },

    formatTime(time) {
      return moment(time).format('DD MMM YYYY hh:mm A');
    },

    exportEmployees() {
      if (this.employees.length === 0) {
        // const snackbar = {
        //   message: 'No employees to export',
        //   color: 'error',
        //   show: true,
        // };
        this.showSnackbar('No employees to export', true);
        return;
      }
      const headers = [
        'Full Name',
        'Email',
        'Phone Number',
        'Department',
        'Designation',
      ];
      const dataArr = this.employees.map((emp) => [
        emp.name,
        emp.email,
        emp.phone,
        emp.department,
        emp.designation,
      ]);

      const config = {
        quotes: true,
        quoteChar: '"',
        delimiter: ',',
        header: true,
        newline: '\r\n',
      };
      const csvData = {
        fields: headers,
        data: dataArr,
      };
      const csv = Papa.unparse(csvData, config);

      const blob = new Blob([csv], {
        type: 'text/csv;charset=utf-8;',
      });

      const filename = `employees_export_${moment().format('DD_MM_YYYY')}.csv`;
      downloadFile(blob, filename);
    },

    editEmployee(employee) {
      this.selectedEmployee = cloneDeep(employee);
      this.editEmployeeDialog = true;
    },
    nav(e) {
      this.$router.push(`/${this.$store.state.profile.role}/employees/${e.id}`);
    },
    deleteEmployee(employee) {
      this.selectedEmployee = cloneDeep(employee);
      this.deleteEmployeeDialog = true;
    },

    confirmDeleteEmployee() {
      this.deleteEmployeeDialog = false;
      firestore
        .collection('tenants')
        .doc(this.$store.state.profile.cid)
        .collection('employees')
        .doc(this.selectedEmployee.id)
        .delete();
    },

    sholudShowError(account) {
      const status = get(account, 'status');
      if (status === 'ERROR' && account.message) return true;
      return false;
    },

    getErrorMessage(account) {
      const message = get(account, 'message');
      return message;
    },

    resendInvite(emp) {
      this.resendInviteDialog = true;
      this.selectedEmployee = cloneDeep(emp);
    },

    resendInviteAll() {
      this.resendInviteDialog = true;
      this.selectedEmployee = {};
    },

    getIdToken() {
      return auth.currentUser.getIdToken(true);
    },

    async resendInviteRequest(eid) {
      const idToken = await this.getIdToken();
      // console.log(idToken);
      return axios.post(
        `${settings.dashboard_url}/api/employee/invite/resend`,
        {
          eid: eid,
        },
        {
          headers: {
            Authorization: `idToken ${idToken}`,
          },
        }
      );
    },

    async confirmResendInvite(eid) {
      this.resendingInvite = true;
      const promises = [];

      if (!eid) {
        this.employees.forEach((emp) => {
          if (emp.id != this.$store.state.profile.uid)
            promises.push(this.resendInviteRequest(emp.id));
        });
      } else {
        promises.push(this.resendInviteRequest(eid));
      }

      try {
        await Promise.all(promises);
        this.showSnackbar('Resend invitation sent successfully');
      } catch (error) {
        console.log(error);
        this.showSnackbar(error, true);
      } finally {
        this.resendingInvite = false;
        this.resendInviteDialog = false;
        this.selectedEmployee = {};
      }
    },

    showSnackbar(message, error) {
      // const snackbar = {
      //   message: `${message}`,
      //   color: error ? 'error' : 'success',
      //   show: true,
      // };
      this.snackbar = true;
      this.snackbarMessage = `${message}`;
      this.snackbarColor = error ? 'error' : 'success';
    },
  },
};
</script>

<style>
#EmployeesTableContent {
  height: calc(100vh - 110px);
}
#employeeTable .v-table__overflow {
  height: calc(100vh - var(--pagination-height));
  overflow-y: scroll;
  overflow-x: visible;
}
</style>
